import { render, staticRenderFns } from "./Dingtalk.vue?vue&type=template&id=abe86cee"
import script from "./Dingtalk.vue?vue&type=script&lang=js"
export * from "./Dingtalk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports